var arrToObj = (arr) => {
  var obj = {};
  arr.forEach((a) => {
    obj[a[0]] = a[1];
  });
  return obj;
};
let types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button",
};

let arr = [
  {
    id: "seq_id",
    label: "Unique Key",
    type: types.INPUT,
    export: {
      enabled: true,
      sequence: 1000,
    },
  },
  {
    id: "approval_status",
    label: "承認状態",
    type: types.SELECT_BOX,
    options: [
      "承認済", // Approved
      "申請中", // Applying
      "下書中", // In draft
      "差戻",
    ],
    table_field_style:{
      "承認済":"color:;",
      "申請中":"color:blue;",
      "下書中":"color:#a0283a",
      "差戻":"color:red;"
    },
    import: { enabled: true },
    export: {// FILE_EXPORT_PART_1 : Step 4.1
      enabled: true,
      sequence: 1000,
      device_embedded_information: "B", 
    },
  },
  {
    id: "device_control_number",
    label: "機器管理番号",
    type: types.INPUT,
    listen_for_value: "device_number_force_update",
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
      device_embedded_information: "D",
    },
  },
  {
    id: "computer_name",
    label: "コンピュータ名",
    type: types.INPUT,
    error_if_blank:true,
    import: {
      enabled: true,
      alias: ["コンピュータ名"],
    },
    export: {
      enabled: true,
      sequence: 1000,
      device_embedded_information: "F",
    },
  },
  {
    id: "virtual_environment",
    label: "仮想環境",
    type: types.SELECT_BOX,
    error_if_blank:true,
    options: ["有", "無"],
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
    },
  },
  {
    id: "virtual_base_unit",
    label: "仮想基盤の親機",
    type: types.INPUT,
    listen_for_value: "device_number_force_update",
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
    },
  },
  {
    id: "company",
    label: "機器所管会社",
    type: types.SELECT_BOX4,
    error_if_blank:true,
    page_controller:true,
    api_uniq_grouping:true,
    default_from_local_storage:"userCompany",
    // api:"/master_company/list_company_name",
    api: "/master_belongs/list_team_and_department",
    api_field_name:"company",
    import: { enabled: true },
    export: {// FILE_EXPORT_PART_1 : Step 4.1
      enabled: true,
      sequence: 1000,
      device_embedded_information: "A", 
    },
    search_dependency:{
      algorithm:"company",
      fields:{
        company: {field:"company",api:"company"},
        department:{field:"equipment_in_charge_department",api:"department"},
        team:{field:"equipment_in_charge_team",api:"team"}
      },
      clear_on_reset:["equipment_in_charge_department","equipment_in_charge_team"]
    }
  },
  {
    id: "equipment_in_charge_department",
    label: "機器所管部署",
    type: types.SELECT_BOX4,
    search_mode_type_ahead:true,
    sort_result:true,
    error_if_blank:true,
    // api: "/master_belongs/list_department",
    api: "/master_belongs/list_team_and_department",
    api_field_name:"department",
    default_from_local_storage:"userDepartment",
    limit_department_on_search:true,
    limit_department_on_load:true,
    page_controller:true,
    api_uniq_grouping:true,
    // global_emit:"equipment_in_charge_department_selected",
    search_option:{
      define_department_limit_to_key:"equipment_in_charge_team"
    },
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
      device_embedded_information: "G",
    },
    search_dependency:{
      algorithm:"company",
      fields:{
        company: {field:"company",api:"company"},
        department:{field:"equipment_in_charge_department",api:"department"},
        team:{field:"equipment_in_charge_team",api:"team"}
      },
      clear_on_reset:["equipment_in_charge_team"]
    }
  },
  {
    id: "equipment_in_charge_team",
    label: "機器所管チーム",
    type: types.SELECT_BOX4,
    search_mode_type_ahead:true,
    sort_result:true,
    error_if_blank:true,
    api_uniq_grouping:true,
    default_from_local_storage:"userTeam",
    api: "/master_belongs/list_team_and_department",
    api_field_name:"team",
    limit_department_on_search:true,
    page_controller:true,
    // api_filter_to_other_field:{
    //   by_field:"equipment_in_charge_department",
    //   compare_api_key:"department",
    //   filter_data_on_event:"equipment_in_charge_department_selected",
    // },
    search_option:{
      define_department_limit_by_key:"equipment_in_charge_department",
      api_field_name:"department",
    },
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
      device_embedded_information: "H"
    },
    search_dependency:{
      algorithm:"company",
      fields:{
        company: {field:"company",api:"company"},
        department:{field:"equipment_in_charge_department",api:"department"},
        team:{field:"equipment_in_charge_team",api:"team"}
      },
      clear_on_reset:[]
    }
  },
  {
    id: "equipment_in_charge_classification",
    label: "所管区分",
    type: types.SELECT_BOX,
    error_if_blank:true,
    options: ["EUC・その他", "IT所管システム"],
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
      device_embedded_information: "I",
    },
  },
  {
    id: "equipment_in_charge_system_it",
    label: "機器所管システム",
    type: types.SELECT_BOX4,
    search_mode_type_ahead:true,
    sort_result:true,
    error_if_blank:true,
    api_uniq_grouping:true,
    api:"/master_system/list_system_name",
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
      device_embedded_information: "J",
    },
  },
  {
    id: "equipment_in_charge_system",
    label: "所管システム/用途",
    type: types.INPUT,
  },
  {
    id: "leasing_or_rental",
    label: "リース/レンタル",
    type: types.SELECT_BOX,
    error_if_blank:true,
    options: ["有", "無"],
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
    },
  },
  {
    id: "manufacture_name",
    label: "メーカ名",
    type: types.INPUT,
    error_if_blank:true,
    import: {
      enabled: true,
      alias: ["メーカ名"],
    },
    export: {
      enabled: true,
      sequence: 1000,
      label: "メーカ名",
    },
  },
  {
    id: "model_name",
    label: "機種名",
    type: types.INPUT,
    error_if_blank:true,
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
    },
  },
  {
    id: "equipment_classification",
    label: "機器区分",
    type: types.SELECT_BOX,
    error_if_blank:true,
    options: ["サーバ", "PC", "その他"],
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
    },
  },
  {
    id: "cpu_count",
    label: "CPU数",
    type: types.INPUT,
    min_value:"0",
    field_type:"number",
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
    },
  },
  {
    id: "remarks",
    label: "備考",
    type: types.TEXT_AREA,
    import: { enabled: true },
    export: { enabled: true, sequence: 1000 },
  },
  {
    id: "retraction_reason",
    label: "差戻通知",
    type: types.TEXT_AREA,
    field_message:"※[差戻通知]は承認完了後削除されます。",
    import: { enabled: true },
    export: { enabled: true, sequence: 1000 },
  },
  {
    id: "installation_department",
    label: "設置部署",
    type: types.SELECT_BOX4,
    error_if_blank:true,
    search_mode_type_ahead:true,
    sort_result:true,
    api: "/master_belongs/list_department",
    default_from_local_storage:"userDepartment",
    limit_department_on_search:true,
    limit_department_on_load:true,
    api_uniq_grouping:true,
    global_emit:"equipment_in_charge_department_selected_in",
    search_option:{
      define_department_limit_to_key:"installation_team"
    },
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
      device_embedded_information: "K",
    },
  },
  {
    id: "installation_team",
    label: "設置チーム",
    type: types.SELECT_BOX4,
    error_if_blank:true,
    search_mode_type_ahead:true,
    sort_result:true,
    default_from_local_storage:"userTeam",
    api: "/master_belongs/list_team_and_department",
    api_field_name:"team",
    limit_department_on_search:true,
    api_uniq_grouping:true,
    // sort_result:true,
    api_filter_to_other_field:{
      by_field:"installation_department",
      compare_api_key:"department",
      filter_data_on_event:"equipment_in_charge_department_selected_in",
    },
    search_option:{
      define_department_limit_by_key:"installation_department",
      api_field_name:"department",
    },
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
      device_embedded_information: "L",
    },
  },
  {
    id: "installation_base",
    label: "設置拠点",
    type: types.INPUT,
    error_if_blank:true,
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
      device_embedded_information: "M",
    },
  },
  {
    id: "floor",
    label: "フロア",
    type: types.INPUT,
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
    },
  },
  {
    id: "user_name",
    label: "使用者名（ﾌﾙﾈｰﾑ）",
    type: types.INPUT,
    error_if_blank:true,
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
      device_embedded_information: "N",
    },
  },
  {
    id: "registration_date",
    label: "登録日",
    type: types.DATE_PICKER,
    export: {
      enabled: true,
      sequence: 1000,
      device_embedded_information: "E",
    },
  },
  {
    id: "last_update_date",
    label: "最終更新日",
    type: types.DATE_PICKER,
  },
  {
    id: "management_person_name",
    label: "管理担当者名（ﾌﾙﾈｰﾑ）",
    type: types.INPUT,
    error_if_blank:true,
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
      device_embedded_information: "O",
    },
  },
  {
    id: "status",
    label: "状態",
    type: types.SELECT_BOX,
    options: ["使用中", "廃棄"],
    options_for_new: ["使用中"],
    import: { enabled: false },
    export: {
      enabled: true,
      sequence: 1000,
      device_embedded_information: "C",
    },
  },
  {
    id: "approval_status_flag",
    label: "approval_status_flag",
    type: types.INPUT,
    import: { enabled: false },
    export: { enabled: false },
  },
  {
    id: "item_number",
    label: "本数",
    type: types.INPUT,
  },

  {
    id: "more_details",
    label: "詳細",
    type: types.INPUT,
  },
  {
    id: "button_options",
    history_label_name: "hide",
    label: "ﾁｪｯｸ",
    type: types.INPUT,
  },
 
];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  }
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;

export const fields = ret;
export const filed_types = types;



// WEBPACK FOOTER //
// ./src/rules/fields_device_embedded_information.js